module.exports = __webpack_public_path__ + "img/booking.94a71d71.svg";